import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get("secondary-nav")) {
  customElements.define(
    "secondary-nav",
    class SecondaryNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.scrollableElement = this.querySelector(
          ".secondary-navigation__ul",
        );
        this.container = this.querySelector(".secondary-navigation");
        this.swiperEl = this.querySelector(".swiper");
        this.dataCenterSlides = this.dataset.centerSlides === "";

        this._wireLinkTapGuard();
        this.initSwiper();
      }

      initSwiper() {
        const scrollToActiveSlide = (swiperEvent) => {
          const activeClass = "secondary-navigation__swiper-slide--active";
          const slides = [...swiperEvent.slides];

          const activeSlideIndex = slides.findIndex((el) =>
            el.classList.contains(activeClass),
          );
          if (activeSlideIndex) {
            const speed = activeSlideIndex * 220;
            swiperEvent.slideTo(activeSlideIndex, speed, true);
          }
        };

        const centerSlides = (swiperEvent) => {
          const shouldBeCentered =
            swiperEvent.snapGrid.length === 1 &&
            swiperEvent.snapGrid[0] === -0;
          swiperEvent.wrapperEl.classList.toggle(
            "secondary-navigation__swiper-wrapper--center",
            shouldBeCentered,
          );
        };

        this.swiper = new Swiper(this.swiperEl, {
          loop: false,
          slidesPerView: "auto",
          spaceBetween: 0,
          init: false,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 1,
            momentumVelocityRatio: 1,
            momentumBounce: false,
            sticky: false,
          },
          speed: 300,
          threshold: 5,
          touchRatio: 1,
          followFinger: true,
          longSwipes: false,
          shortSwipes: true,
          simulateTouch: true,
          breakpoints: {
            900: {
              freeMode: false,
              speed: 150,
              simulateTouch: false,
            },
          },
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });

        this.swiper.on("afterInit", scrollToActiveSlide);
        if (this.dataCenterSlides) {
          this.swiper.on("init", centerSlides);
          this.swiper.on("resize", centerSlides);
        }

        this.swiper.init();
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }

      /*
        Small in-pill spinner on the clicked link only. Wraps the label
        text in a span so we can hide it while keeping the pill width;
        does NOT use the theme's .spinner-ring class (that defaults to
        64px and was rendering giant rings between pills).
      */
      _showLoading(link) {
        if (
          !link ||
          !link.classList.contains("secondary-navigation__link") ||
          link.classList.contains("secondary-navigation__link--loading")
        ) {
          return;
        }

        const labelText = link.textContent.trim();
        if (labelText && !link.querySelector(".secondary-navigation__link-label")) {
          link.textContent = "";
          const label = document.createElement("span");
          label.className = "secondary-navigation__link-label";
          label.textContent = labelText;
          link.appendChild(label);
        }

        if (!link.querySelector(".secondary-navigation__link-spinner")) {
          const spinner = document.createElement("span");
          spinner.className = "secondary-navigation__link-spinner";
          spinner.setAttribute("aria-hidden", "true");
          link.appendChild(spinner);
        }

        link.classList.add("secondary-navigation__link--loading");
        link.setAttribute("aria-busy", "true");
      }

      /*
        Tap-vs-swipe guard for pill links in the free-scrolling strip.
        Swipe drift >10px cancels the click. On a valid click, show the
        in-pill spinner and let the native <a href> navigate normally.
      */
      _wireLinkTapGuard() {
        const LINK_SEL =
          ".secondary-navigation__link, .secondary-navigation__thumbnail";
        const TAP_MOVE = 10;
        let gesture = null;

        this.addEventListener(
          "pointerdown",
          (e) => {
            const link = e.target.closest(LINK_SEL);
            if (!link || !this.contains(link)) {
              gesture = null;
              return;
            }
            if (e.pointerType === "mouse" && e.button !== 0) {
              gesture = null;
              return;
            }
            gesture = {
              link,
              pointerId: e.pointerId,
              x: e.clientX,
              y: e.clientY,
              cancelled: false,
            };
          },
          true,
        );

        this.addEventListener(
          "pointermove",
          (e) => {
            if (!gesture || e.pointerId !== gesture.pointerId) return;
            const dx = Math.abs(e.clientX - gesture.x);
            const dy = Math.abs(e.clientY - gesture.y);
            if (dx > TAP_MOVE || dy > TAP_MOVE) {
              gesture.cancelled = true;
            }
          },
          { passive: true, capture: true },
        );

        this.addEventListener(
          "pointercancel",
          () => {
            gesture = null;
          },
          true,
        );

        this.addEventListener(
          "click",
          (e) => {
            const link = e.target.closest(LINK_SEL);
            if (!link) return;

            if (gesture?.cancelled && gesture.link === link) {
              e.preventDefault();
              e.stopPropagation();
              gesture = null;
              return;
            }

            if (link.classList.contains("secondary-navigation__link")) {
              this._showLoading(link);
            }

            gesture = null;
          },
          true,
        );
      }
    },
  );
}
